import config from './config.common.mjs';

export default config({
	env: 'production',
});
